// Dot-path → human-readable timeline label.
//   "heading"            → "Heading"
//   "steps.2.title"      → "Step 3 Title"
//   "stats.1.value"      → "Stat 2 Value"

const ARRAY_NAMES = {
  items: "Item",
  steps: "Step",
  stats: "Stat",
  bullets: "Bullet",
  cards: "Card",
  columns: "Column",
};

function titleCase(s) {
  if (!s) return s;
  return s
    .replace(/[-_]/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .split(/\s+/)
    .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1) : w))
    .join(" ");
}

export function humanizeFieldPath(path) {
  if (!path || typeof path !== "string") return "Element";

  const stripped = path.replace(/\.?(boxAnimation|boxExitAnimation)$/, "");
  if (!stripped) return "Element";

  const parts = stripped.split(".");
  const out = [];

  for (let i = 0; i < parts.length; i++) {
    const seg = parts[i];
    const prev = parts[i - 1];
    if (/^\d+$/.test(seg)) {
      const singular = ARRAY_NAMES[prev] || titleCase(prev) || "Item";
      out[out.length - 1] = `${singular} ${parseInt(seg, 10) + 1}`;
    } else {
      out.push(titleCase(seg));
    }
  }

  return out.join(" ").trim() || "Element";
}

export default humanizeFieldPath;
